
<style lang="less" scoped>
.content {
  background: #f2f3f4;
  position: relative;
  padding-bottom: 5px;
}
/deep/.ivu-input-icon {
  top: 2px;
  right: 2px;
}
.banner {
  height: 200px;
  background: url(../assets/images/banner.png) no-repeat 100% 20%;
  .cstr {
    img {
      width: 80px;
      margin-bottom: 10px;
    }
  }
  .enCstr {
    padding-top: 55px;
    text-align: center;

    p {
      color: #fff;
      font-size: 14px;
    }
  }
  h2 {
    color: #fff;
    padding-top: 4.5rem;
    font-weight: normal;

    text-align: center;
    font-size: 14px;
  }
}
.main {
  position: relative;
}

.tabsData {
  padding: 5px 10px 0px;
  box-sizing: border-box;
}
.tabsData /deep/.ivu-input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  overflow: hidden;
  display: flex;
  flex: 1;
  resize: none;
  position: relative;
  padding-right: 35px !important;
  padding-left: 10px;
  height: 35px;
  line-height: 35px;
  border-radius: 50px !important;
  font-size: 12px;
}

/deep/.ivu-icon-ios-search:before {
  font-size: 22px;
}
i {
  font-size: 14px;

  font-style: normal;
  font-weight: 550;
  font-family: "DIN-Medium", Arial;
}
.nums {
  margin-top: -35px;
}
#hideMembers {
  padding-top: 0 !important;
  display: none;
}
#third {
  display: none;
}
.dataStatic {
  display: flex;
  padding: 15px 5px;
  margin: 0 10px 5px;
  z-index: 88;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: space-evenly;
  li {
    padding: 5px 0;
    background: #fff;
    position: relative;
    cursor: pointer;
    // border-bottom: 1px dashed #a09a9a;
    width: 48%;
    box-sizing: border-box;
  }

  li:nth-child(2n) {
    margin-right: 0 !important;
  }

  .datas {
    text-align: center;
    line-height: 18px;
    font-weight: 550;

    box-sizing: border-box;
  }
  .hover {
    border-right: 0.08333rem dashed #a09a9a;
  }
}

/deep/.ivu-input-wrapper {
  flex: 1;
}
.seeMore img {
  width: 20px;
  position: absolute;
  bottom: -2px;
  right: 46.955%;
  z-index: 999;
}

.datas span {
  display: block;
  font-size: 12px;
  color: #070707db;
  text-align: center;
  font-weight: 550;
  box-sizing: border-box;
}
#third {
  position: relative;
}

.seeMore2 {
  display: none;
  img {
    width: 14px !important;
  }
}
.unit {
  font-size: 10px !important;
  margin-left: 2px;
}
.news {
  padding: 0.83333rem;
  margin: 10px 0.83333rem 0.41667rem;
  box-sizing: border-box;
  background: #ffff;
  .high {
    color: #333333;
    display: flex;
    font-size: 12px;
    font-weight: bold;
    justify-content: space-between;
  }
  .more {
    font-size: 10px;
  }
  .cscd_css {
    font-size: 10px;
    padding-bottom: 3px;
  }
}
.news ul li {
  font-size: 10px;
  p {
    padding-bottom: 3px;
  }
}
.title {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
  font-size: 10px;
  line-height: 18px;
}
.links img {
  width: 20px;
  margin-right: 2px;
}
.authors {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.addQuote div {
  padding: 2px 0;
  box-sizing: border-box;
}
.keyword {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.register {
  border-bottom: 1px dashed #333;
  // padding: 5px 0;
}
.news ul:first-child li .register {
  padding-bottom: 5px;
}
.news ul li:last-child .register {
  border-bottom: none;
  padding-top: 5px;
}
.Latest {
  box-sizing: border-box;
  background: #fff;
  margin: 5px 10px;
  padding: 10px;
  .time {
    font-weight: normal;
  }
  h2 {
    font-size: 1rem;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }
  ul {
    li {
      font-size: 12px;
      line-height: 25px;
      overflow: hidden;
      .numbers {
        float: right;
        color: #333;
        font-weight: 600;
      }
    }
  }
}

.notice {
  position: relative;
  a {
    color: #ffffff;
    font-size: 10px;
    line-height: 18px;
    display: inline-block;
  }
  .close {
    position: absolute;
    right: -4px;
    font-size: 12px;
    top: -6px;
  }
}

.block span {
  border: 1px solid red;
  border-radius: 0.3125rem;
  padding: 0 0.3125rem;
  font-size: 0.75rem;
  display: inline-block;
  margin-right: 0.625rem;
}
.influenceFacto {
  border: 0.0625rem solid #656464;
  color: red;
  border-radius: 0.1875rem;
  padding: 0 0.3125rem;
  margin-left: 0.41667rem;
  font-size: 0.75rem;
  display: inline-block;
  margin-right: 0.625rem;
}
</style>
<template>
  <div>
    <!-- <ComHeader /> -->
    <div class="content">
      <div class="main">
        <ComHeader />
        <div class="banner">
          <div class="cstr">
            <h2>{{ $t("header.title") }}<br />{{ $t("header.subtitle") }}</h2>
          </div>

          <div class="tabsData">
            <Input
              class="div_show"
              v-model.trim="tabpane1"
              :placeholder="$t('main.home1')"
              @keyup.enter.native="search_data"
              search
              @on-search="search_data"
            >
            </Input>
          </div>
        </div>

        <div class="nums">
          <ul class="dataStatic">
            <li @click="queryData('v3_article_data')">
              <div class="datas hover">
                <span>{{ $t("keywords.keywords14") }}</span>
                <i v-if="lang != 'en'">{{
                  $formatNumberAsTenThousand(paperCounts)
                }}</i>
                <i v-else>{{ paperCounts.toLocaleString() }}</i>
              </div>
            </li>
            <li @click="queryData('v3_dissertation_data')">
              <div class="datas">
                <span>{{ $t("header.home33") }}</span>
                <i v-if="lang != 'en'">{{
                  $formatNumberAsTenThousand(dissertationCount)
                }}</i>
                <i v-if="lang == 'en'">{{
                  dissertationCount.toLocaleString()
                }}</i>
              </div>
            </li>
            <li @click="queryData('v3_scientific_data')">
              <div class="datas hover">
                <span>{{ $t("header.home2") }}</span>
                <i v-if="lang != 'en'">{{
                  $formatNumberAsTenThousand(enTotal)
                }}</i>
                <i v-if="lang == 'en'">{{ enTotal.toLocaleString() }}</i>
              </div>
            </li>
            <li class="datas" @click="queryData('v3_patent_data')">
              <div class="datas">
                <span>{{ $t("header.home28") }}</span>
                <i v-if="lang != 'en'">{{
                  $formatNumberAsTenThousand(patentCount)
                }}</i>
                <i v-else>{{ patentCount.toLocaleString() }}</i>
              </div>
            </li>
          </ul>
          <div id="hideMembers">
            <ul class="dataStatic">
              <li @click="queryData('v3_preprint_data')">
                <div class="datas hover">
                  <span>{{ $t("header.home27") }}</span>
                  <i v-if="lang != 'en'">{{
                    $formatNumberAsTenThousand(preprintCount)
                  }}</i>
                  <i v-if="lang == 'en'">{{
                    preprintCount.toLocaleString()
                  }}</i>
                </div>
              </li>
              <li @click="queryData('v3_species_data')">
                <div class="datas">
                  <span>{{ $t("header.home31") }}</span>
                  <i v-if="lang != 'en'">{{
                    $formatNumberAsTenThousand(speciesCount)
                  }}</i>
                  <i v-if="lang == 'en'">{{ speciesCount.toLocaleString() }}</i>
                </div>
              </li>
              <li @click="queryData('v3_equipment_data')">
                <div class="datas">
                  <span>{{ $t("header.home25") }}</span>
                  <i>152</i>
                </div>
              </li>
              <li class="datas" @click="queryData('v3_bioresource_data')">
                <div class="datas">
                  <span>{{ $t("header.home24") }}</span>
                  <i v-if="lang != 'en'">{{
                    $formatNumberAsTenThousand(germplasmCount)
                  }}</i>
                  <i v-if="lang == 'en'">{{
                    germplasmCount.toLocaleString()
                  }}</i>
                </div>
              </li>
            </ul>
          </div>
          <div id="third">
            <ul class="dataStatic">
              <li @click="queryData('v3_infrastructure_data')">
                <div v-if="lang == 'en'" class="datas hover">
                  <span>{{ $t("header.facility") }}</span>
                  <i>{{ infrastructureCount.toLocaleString() }}</i>
                </div>
                <div v-else class="datas hover">
                  <span>{{ $t("header.facility") }}</span>
                  <i>{{ $formatNumberAsTenThousand(infrastructureCount) }}</i>
                </div>
              </li>
              <li class="datas">
                <div class="datas">
                  <span>{{ $t("header.home3") }}</span>
                  <div v-if="lang == 'en'" class="datas">
                    <i>{{ personCount.toLocaleString() }}</i>
                  </div>
                  <div v-else class="datas">
                    <i>{{ $formatNumberAsTenThousand(personCount) }}</i>
                  </div>
                </div>
              </li>

              <p class="seeMore seeMore2">
                <!-- <a class="viewMore1">收起</a> -->
                <a class="viewMore1">
                  <img src="@/assets/images/hide.png" />
                </a>
              </p>
            </ul>
          </div>

          <p class="seeMore seeMore1">
            <a class="viewMore">
              <img src="@/assets/images/arrow.png" />
            </a>
          </p>
        </div>
      </div>
      <div class="Latest">
        <ul>
          <h2>
            {{ $t("header.dynamic") }}
            <span class="time"
              >{{ $t("quote.quote8") }}&nbsp; {{ updateTime }}</span
            >
          </h2>
          <li v-for="(item, index) in addData" :key="index">
            <span v-if="item.total > 0">
              <span v-if="lang != 'en'">
                <Badge status="warning" />{{ item.name }}</span
              >
              <span v-else> <Badge status="warning" />{{ item.nameEn }}</span
              ><span class="numbers">{{ item.total }}</span>
            </span>
          </li>
        </ul>
      </div>
      <div class="news">
        <ul>
          <p class="high">
            {{ $t("diss.diss12")
            }}<a class="more" @click="highestReference"
              >{{ $t("diss.diss17") }}>></a
            >
          </p>
          <p class="cscd_css">
            Data source : <span class="cscd_css">CSCD</span>
            &nbsp;|&nbsp;
            <span class="cscd_css" style="cursor: text">Google Scholar</span>
          </p>
          <li v-for="(item, index) in newsReferenceData" :key="index">
            <div class="menu">
              <p class="title" @click="registerDetail(item)">
                <a target="_blank">{{ item.dataSetName }}</a>
              </p>

              <p class="authors">
                {{ item.author }}
              </p>
              <p class="authors" v-if="item.author != item.institutionName">
                {{ item.institutionName }}
              </p>
              <p v-if="item.ctime">
                <span>{{ item.ctime.substring(0, 10) }}</span>
              </p>
              <p class="links">
                <a
                  class="date"
                  :title="$t('newTip.newTip1')"
                  :href="'https://cstr.cn/' + $checkPrefix(item.identifier)"
                  target="_blank"
                >
                  <img class="link" src="@/assets/images/nav.png" />{{
                    item.identifier
                  }}
                </a>
              </p>
            </div>
            <div class="addQuote">
              <div>
                <span style="color: rgb(0, 0, 0)">{{ $t("diss.diss16") }}</span>
              </div>
              <p class="paperTitle">
                <a
                  class="date"
                  target="_blank"
                  :href="item.url"
                  style="text-decoration: underline"
                  >{{ item.resourceChineseName }}</a
                >
              </p>
              <p class="citedJournalName">
                <span v-if="item.citedJournalName" style="margin-right: 5px"
                  >《{{ item.citedJournalName }}》</span
                >
                <span class="block" v-if="item.databases">
                  <span
                    v-for="(items, indexs) in item.databases"
                    :key="indexs"
                    >{{ items + " " }}</span
                  ></span
                >
                <span class="block" v-if="item.region">
                  <span v-for="(items, indexs) in item.region" :key="indexs">{{
                    items.source + " : " + items.rank
                  }}</span></span
                >
                <span
                  v-if="item.influenceFacto !== '0.0'"
                  class="influenceFacto"
                >
                  IF : {{ item.influenceFacto }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="news">
        <ul>
          <p class="high">
            {{ $t("diss.diss13")
            }}<a class="more" @click="newsRegister"
              >{{ $t("diss.diss17") }}>></a
            >
          </p>
          <p class="cscd_css">
            Data source : <span class="cscd_css">CSTR</span>
          </p>
          <li v-for="(item, index) in registerData" :key="index">
            <div class="menu register">
              <p class="title" @click="registerDetail(item)">
                <a
                  v-if="(lang != 'en' && item.title1) || !item.title2"
                  class="t"
                  target="_blank"
                  v-html="item.title1"
                ></a>
                <a v-else class="t" target="_blank" v-html="item.title2"></a>

                <!-- <span>{{ item.ctime.substring(0, 10) }}</span> -->
              </p>
              <p v-if="item.registrant">
                {{ item.registrant }}
              </p>
              <p>
                <span v-if="item.ctime">{{ item.ctime.substring(0, 10) }}</span>
              </p>
              <p
                class="keyword"
                v-if="
                  (lang != 'en' && item.keywordsZh) || item.keywordsEn == ''
                "
              >
                {{ item.keywordsZh }}
              </p>
              <p class="keyword" v-else>
                {{ item.keywordsEn }}
              </p>
              <p class="links keyword">
                <a
                  class="date"
                  :href="'https://cstr.cn/' + $checkPrefix(item.identifier)"
                  target="_blank"
                >
                  <img class="link" src="@/assets/images/nav.png" />{{
                    item.identifier
                  }}
                </a>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="news">
        <ul>
          <p class="high">
            {{ $t("diss.diss14")
            }}<a class="more" @click="newsResolve">{{ $t("diss.diss17") }}>></a>
          </p>
          <p class="cscd_css">
            Data source : <span class="cscd_css">CSTR</span>
          </p>
          <li v-for="(item, index) in resolveData" :key="index">
            <div class="menu register">
              <p class="title" @click="registerDetail(item)">
                <a
                  v-if="
                    (lang != 'en' && item.resourceChineseName) ||
                    item.resourceName == ''
                  "
                  class="t"
                  target="_blank"
                  >{{ item.resourceChineseName }}</a
                >
                <a v-else class="t" target="_blank">{{ item.resourceName }}</a>
              </p>

              <p v-if="(lang != 'en' && item.nameZh) || !item.nameEn">
                {{ item.nameZh }}
              </p>
              <p v-if="lang == 'en' && item.nameEn">{{ item.nameEn }}</p>
              <p v-if="item.resolve_time">
                <span>{{ item.resolve_time.substring(0, 10) }}</span>
              </p>
              <p class="links keyword">
                <a
                  class="date"
                  :href="'https://cstr.cn/' + $checkPrefix(item.identifier)"
                  target="_blank"
                >
                  <img class="link" src="@/assets/images/nav.png" />{{
                    item.identifier
                  }}
                </a>
              </p>
              <p>
                <span v-if="lang != 'en'"
                  >{{ $t("diss.diss10") }}{{ item.country }}</span
                ><span v-else>{{ $t("diss.diss10") }}{{ item.countryEn }}</span
                >&nbsp;|&nbsp;<span
                  >{{ $t("diss.diss11") }}{{ item.resolve_count }}</span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="news">
        <ul>
          <p class="high">
            {{ $t("diss.diss15")
            }}<a class="more" @click="lastReferenceData"
              >{{ $t("diss.diss17") }}>></a
            >
          </p>
          <p class="cscd_css">
            Data source : <span class="cscd_css">CSCD</span>
            &nbsp;|&nbsp;
            <span class="cscd_css" style="cursor: text">Google Scholar</span>
          </p>
          <li v-for="(item, index) in highestReferenceData" :key="index">
            <div class="menu register">
              <p class="title" @click="registerDetail(item)">
                <a class="t" target="_blank">{{ item.title1 }}</a>
              </p>

              <p class="keyword" v-if="item.author">
                {{ item.author }}
              </p>
              <p v-if="item.publish_date">
                <span>{{ item.publish_date }}</span>
              </p>
              <p class="links keyword">
                <a
                  class="date"
                  :href="'https://cstr.cn/' + $checkPrefix(item.identifier)"
                  target="_blank"
                >
                  <img class="link" src="@/assets/images/nav.png" />{{
                    item.identifier
                  }}
                </a>
              </p>
              <p v-if="item.cite_total">
                <span>{{ $t("person.quoteTotal") }} </span
                ><a style="cursor: default">{{ item.cite_total }}</a>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 最新新闻 -->
      <newsData></newsData>
    </div>

    <ComFooter></ComFooter>
  </div>
</template>
<script>
let params = {
  page: 1,
  size: 2,
  type: "",
};
import ComHeader from "@/components/header.vue";

import $ from "jquery";
// import newsList from "./datas.vue";
import newsData from "./news/NewsData.vue";
import "swiper/dist/css/swiper.min.css";
import ComFooter from "@/components/footer.vue";
export default {
  inject: ["reload"],
  components: {
    ComHeader,
    ComFooter,
    // newsList,
    newsData,
  },
  data() {
    return {
      tabpane1: "",
      total1s: 0,
      addData: [],
      paperCounts: 0,
      dissertationCount: 0,
      infrastructureCount: 0,
      patentCount: 0,
      preprintCount: 0,
      speciesCount: 0,
      personCount: 1500598,
      newsReferenceData: [],
      registerData: [],
      germplasmCount: 0,
      resolveData: [],
      referenceData: [],
      dataCount: {},
      highestReferenceData: [],
      selectData: [],
      dissTotal: 0,
      updateTime: "",
      science: true,
      people: false,
      project: false,
      prefix: false,
      organ: false,
      row: {},
      lang: "",
    };
  },
  mounted() {
    this.selectData = require("../assets/data/type.json").lists;
    $(function () {
      $(".viewMore").click(function () {
        $("#hideMembers").slideDown();
        $("#third").slideDown();
        $(".seeMore1").hide();
        $(".seeMore2").show();
      });
      $(".viewMore1").click(function () {
        $("#hideMembers").slideUp();
        $("#third").slideUp();
        $(".seeMore2").hide();
        $(".seeMore1").show();
      });
    });
    this.lang = this.$cookie.get("lang");
    this.getTotalData();
    this.getAddData();

    // this.getReserenceData();
    // this.getRegister();
    // this.getResolveData();
    // this.getQuote();

    this.getlasterMetadataList("latest_reference"); //最新被引
    this.getlasterMetadataList("latest_register"); //最新注册
    this.getlasterMetadataList("latest_resolve"); //最新解析
    this.getlasterMetadataList("highest_reference"); //最高被引
  },
  created() {},
  methods: {
    getTotalData() {
      this.$api.getResourceTypeRegister().then((res) => {
        if (res.data.code == 200) {
          let items = res.data.items;
          items.forEach((item) => {
            if (item.resource_type == "学位论文") {
              this.dissertationCount = item.total;
            } else if (item.resource_type == "学术论文") {
              this.paperCounts = item.total;
            } else if (item.resource_type == "科学数据") {
              this.enTotal = item.total;
              this.totals = this.enTotal.toString().substring(0, 3);
            } else if (item.resource_type == "种质资源") {
              this.germplasmCount = item.total;
            } else if (item.resource_type == "专利") {
              this.patentCount = item.total;
            } else if (item.resource_type == "预印本") {
              this.preprintCount = item.total;
            } else if (item.resource_type == "重大科技基础设施") {
              this.infrastructureCount = item.total;
            } else if (item.resource_type == "生物物种") {
              this.speciesCount = item.total;
            } else if (item.resource_type == "仪器设备") {
              this.equipmentCount = item.total;
            }
          });

          // this.totals = this.enTotal.toString().substring(0, 3);
        }
      });
    },

    checkPrefix(pid) {
      //去空格 转大写
      pid = pid.replace(/\s+/g, "").toUpperCase();
      var cstrReg = /^\d{5}.\d{2}.*/;
      //
      if (pid.startsWith("DOI")) {
        return pid.replace("DOI:", "");
      } else if (pid.startsWith("CSTR")) {
        return pid;
      } else if (cstrReg.test(pid)) {
        //cstr 无前缀补全
        return "CSTR:" + pid;
      } else if (pid.startsWith("ORCID")) {
        return pid.replace("ORCID:", "");
      } else if (pid.startsWith("ID")) {
        return pid.replace("ID:", "");
      }
      return pid;
    },
    // 新增数据
    getAddData() {
      this.$api.addData().then((res) => {
        if (res.data.code == 200) {
          if (res.data.items && res.data.items.length > 0) {
            var arr = res.data.items;
            this.selectData = require("../assets/data/type.json").lists;
            arr.map((val) => {
              this.selectData.map((item) => {
                if (val.resource_type != "其他") {
                  if (val.resource_type == item.name) {
                    this.addData.push({
                      total: val.total,
                      name: item.name,
                      nameEn: item.nameEn,
                    });
                    this.addData.sort((a, b) => b.total - a.total);
                  }
                }
              });
            });
          }
          //  获取昨日日期

          this.updateTime = res.data.items[0].register_date;
        }
      });
    },
    getlasterMetadataList(type) {
      this.$api.getlasterMetadataList(type).then((res) => {
        if (res.data.code == 200) {
          var res = res.data;
          var items = [];
          res.items.forEach((item) => {
            items.push(JSON.parse(item.metadata));
          });
          if (type == "latest_reference") {
            var arr = items;
            arr.map((val) => {
              var databases, region, paperAuthor;
              if (
                val.databases &&
                val.databases != "None" &&
                val.databases != "none"
              ) {
                databases = JSON.parse(val.databases.replace(/'/g, '"'));
              }
              if (
                val.region &&
                val.region != "None" &&
                val.databases != "none"
              ) {
                region = JSON.parse(val.region.replace(/'/g, '"'));
              }
              if (val.paperAuthor) {
                paperAuthor = val.paperAuthor.split(";");
              }
              this.newsReferenceData.push({
                dataSetName: val.dataSetName,
                author: val.author,
                institutionName: val.institutionName,
                identifier: val.identifier,
                resourceChineseName: val.resourceChineseName,
                citedJournalName: val.citedJournalName,
                databases: databases,
                region: region,
                ctime: val.ctime,
                fieldMap: val.fieldMap,
                paperAuthor: paperAuthor,
                updateTime: val.updateTime,
                influenceFacto: val.influenceFacto,
                url: val.url,
              });
            });
            console.log(this.newsReferenceData);
          } else if (type == "latest_register") {
            this.registerData = items;
          } else if (type == "latest_resolve") {
            this.resolveData = items;
          } else if (type == "highest_reference") {
            this.highestReferenceData = items;
          }
        } else if (res.data.code == 500) {
          this.showData = false;
          this.$Notice.warning({
            title: res.data.message,
          });
        }
      });
    },
    highestReference() {
      if (this.lang != "en") {
        this.$router.push({
          name: "parseQuote",
        });
      } else {
        this.$router.push({
          name: "EnparseQuote",
        });
      }
    },

    newsRegister() {
      if (this.lang != "en") {
        this.$router.push({
          path: "search/newRegister",
        });
      } else {
        this.$router.push({
          path: "en/search/newRegister",
        });
      }
      this.reload();
    },
    newsResolve() {
      if (this.lang != "en") {
        this.$router.push({
          path: "search/newResolve",
        });
      } else {
        this.$router.push({
          path: "en/search/newResolve",
        });
      }
      this.reload();
    },
    lastReferenceData() {
      if (this.lang != "en") {
        this.$router.push({
          path: "search/MostCited",
        });
      } else {
        this.$router.push({
          path: "en/search/MostCited",
        });
      }
    },

    search_data() {
      if (this.tabpane1 != "") {
        var cstrReg1 =
          /[CSTR:](\d{5}|[a-zA-Z]{5}|[a-zA-Z]\d{4}|[a-zA-Z]{2}\d{3}|[a-zA-Z]{3}\d{2}|[a-zA-Z]{4}\d).\d{2}.*/;
        var DOI = /^\d{2}.(\d{1,10}\/.*|\d{1,10}.*)/;
        var orcidReg = /^\d{4}-\d{4}-\d{4}-(\d|X|x){4}/;
        var links = cstrReg1.test(this.checkPrefix(this.tabpane1));
        if (
          orcidReg.test(this.checkPrefix(this.tabpane1)) ||
          links ||
          this.tabpane1.toUpperCase().startsWith("EU:") ||
          this.tabpane1.toUpperCase().startsWith("NSF:") ||
          this.tabpane1.startsWith("grid") ||
          this.tabpane1.toUpperCase().startsWith("HTTPS://ROR.ORG") ||
          /^(DOI:|doi:)?10\.\d{1,10}(\.\d{1,10})?\/.*$/.test(this.tabpane1) ||
          /^21\.\d{1,10}(\.\d{1,10})?\/.*$/.test(
            this.checkPrefix(this.tabpane1)
          )
        ) {
          window.open("https://cstr.cn/" + this.checkPrefix(this.tabpane1));
        } else {
          this.$router.push({
            name: "SearchList",
            query: {
              value: this.tabpane1,
              type: "all",
            },
          });
        }
      } else {
        this.$Message.error({
          background: true,
          content: this.$t("message.message"),
        });
      }
    },
    queryData(val) {
      if (this.lang == "en") {
        location.href = "/phone/en/search/search?params=" + val;
      } else {
        location.href = "/phone/search/search?params=" + val;
      }
    },

    registerDetail(item) {
      var link = "/detail?identifier=" + item.identifier;
      window.open(link, "_blank");
    },
  },
};
</script>